import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db, auth } from "./firebase";

const UserList = ({ onSelectUser }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "users"), (snapshot) => {
      const userList = snapshot.docs
        .map((doc) => ({ uid: doc.id, ...doc.data() }))
        .filter((user) => user.uid !== auth.currentUser?.uid);
      setUsers(userList);
    });
    return () => unsub();
  }, []);

  return (
    <div style={{ padding: "10px", minWidth: "220px" }}>
      <h3>Users</h3>
      {users.length === 0 ? (
        <p>No other users available</p>
      ) : (
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {users.map((u) => (
            <li
              key={u.uid}
              onClick={() => onSelectUser(u)}
              style={{
                cursor: "pointer",
                margin: "10px 0",
                display: "flex",
                alignItems: "center",
                padding: "5px 8px",
                borderRadius: "8px",
              }}
            >
              <img
                src={u.photoURL || "https://via.placeholder.com/40"}
                alt="avatar"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  marginRight: "12px",
                  objectFit: "cover",
                }}
              />
              <span style={{ fontWeight: 500 }}>{u.name || u.email}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default UserList;
